export enum TitleInputLanguageType {
  ENGLISH = 'english',
  ARABIC = 'arabic',
}
